function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Forms_svg__3_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4F9FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F8E7FF"
})), React.createElement("linearGradient", {
  id: "Forms_svg__4_b",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DFE",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#B97AD3",
  stopOpacity: 0.2
})), React.createElement("linearGradient", {
  id: "Forms_svg__5_c",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#D576F0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Forms_svg__3_a)",
  stroke: "url(#Forms_svg__4_b)",
  d: "M47.303 47.303A7.477 7.477 0 0142 49.5H8a7.477 7.477 0 01-5.303-2.197A7.477 7.477 0 01.5 42V8c0-2.071.84-3.946 2.197-5.303A7.477 7.477 0 018 .5h34c2.071 0 3.946.84 5.303 2.197A7.477 7.477 0 0149.5 8v34c0 2.071-.84 3.946-2.197 5.303z"
}), React.createElement("path", {
  fill: "url(#Forms_svg__5_c)",
  d: "M37 22v6c0 1.591-1.193 3-3 3h-5c-.602 0-1-.47-1-1s.398-1 1-1h5c.602 0 1-.47 1-1v-6c0-.53-.398-1-1-1h-5c-.602 0-1-.47-1-1s.398-1 1-1h5c1.807 0 3 1.409 3 3zm-15.273-9h.546c1.027 0 2.01.415 2.727 1.15A3.806 3.806 0 0127.727 13h.546a1.09 1.09 0 110 2.182h-.546c-.903 0-1.726.733-1.727 1.636v16.364c.001.903.824 1.635 1.727 1.636h.546a1.09 1.09 0 110 2.182h-.546A3.806 3.806 0 0125 35.85 3.806 3.806 0 0122.273 37h-.546a1.09 1.09 0 110-2.182h.546c.903 0 1.726-.733 1.727-1.636V16.818c-.001-.903-.824-1.635-1.727-1.636h-.546a1.09 1.09 0 110-2.182zM21 29c.602 0 1 .47 1 1s-.398 1-1 1h-5c-1.807 0-3-1.409-3-3v-6c0-1.591 1.193-3 3-3h5c.602 0 1 .47 1 1s-.398 1-1 1h-5c-.602 0-1 .47-1 1v6c0 .53.398 1 1 1h5z"
}));

var SvgForms = function SvgForms(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgForms;